<template>
  <i v-if="name" class="icon" :class="[size,{ circled:isCircled}]" >
    <svg :style="styles">
      <use :xlink:href="svgSprite" />
    </svg>
  </i>
</template>
<script setup lang="ts">
import { computed, toRefs, type ComputedRef } from 'vue';

import type { Props } from './model';

defineOptions({
  name: 'IconDefault'
});

const props = withDefaults(defineProps<Props>(), {
  name: '',
  styles: '',
  size:'',
  isCircled:false

});

const { name, styles, isCircled } = toRefs(props);

const svgSprite: ComputedRef<string> = computed(() => {
  return `/img/sprites.svg#${name.value}`;
})
</script>
<style  lang="scss">
.icon {
  display: block;
  font-style: normal;
  font-size: var(--base-font-size);
  flex-shrink: 0;
  line-height: 1;
  transition: all .4s;
  svg {
    height: 1em;
    width: 1em;
    vertical-align: middle;
    transition: transform .3s ease-in-out;
  }
  &.circled{
    &.m{
      width: var(--space-45);
      height: var(--space-45);
      border-radius: 50%;
      background: transparent;
      color: var(--color-secondary);
      border: 0.1rem solid var(--color-secondary);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0.6rem;
      &:hover{
        color: var(--color-primary);
        border-color: var(--color-primary);
      }
    }
  }
  &.l{
    font-size: var(--space-56);
  }
  &.m:not(.circled){
    width: var(--space-45);
    height: var(--space-45);
    font-size: var(--space-42);
    line-height: var(--space-42);
  }

  &.s{
    font-size: var(--space-14);
    color: var(--color-secondary);
    margin-right: .5rem;
    &:hover{
      color: var(--color-primary);
    }
  }
  &.xs{
    font-size: var(--space-24);
    color: var(--color-secondary);
    &:hover{
      color: var(--color-primary);
    }
  }
}

</style>